import React from 'react';
import PropTypes from 'prop-types';
import {FormGroup} from 'reactstrap';

const Fieldset = (props) =>
    <FormGroup className={props.className} tag="fieldset" hidden={props.hidden}>
        <legend>{props.legend}</legend>
        {props.children}
    </FormGroup>

Fieldset.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired
}

export default Fieldset;


// WEBPACK FOOTER //
// ./src/app/components/Fieldset.js